var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaitama(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 900 650",
    width: 900,
    height: 650,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-id-viewbox-item-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.0 -25.0) rotate(0.0 365.0 365.0) scale(15.208333333333334 15.208333333333334)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-id-viewbox-item-0)",
    transform: "translate(-0.0 -0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M33.6 24.9c0 2.7.1 7.1 2.1 7.1s4.3-4.9 4.3-7.6S39.4 20 37.3 20 33.6 22.2 33.6 24.9zM14.4 24.9c0 2.7-.1 7.1-2.1 7.1S8 27.1 8 24.4 8.6 20 10.7 20 14.4 22.2 14.4 24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fece2f",
    d: "M24,2c-7.7,0-14,6.7-14,15.1c0,5.4,1.9,16.6,4,19.9c2.1,3.2,7.3,7,10,7s7.9-3.8,10-7 c2.1-3.3,4-14.5,4-19.9C38,8.7,31.7,2,24,2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0b2",
    d: "M33,10.1c0-1.9-1.6-3.6-3.7-4C28.9,6,28,5.9,28,6.9c0,1.9,1.6,3.6,3.7,4C32.1,11,33,11.1,33,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35,22.2c0-1.3-4.6-1.3-4.6-1.3S27,21,27,23.5c0,1.8,2.8,2.5,4.4,2.5C33.2,26,35,24.7,35,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M31 22A1 1 0 1 0 31 24A1 1 0 1 0 31 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6d00",
    d: "M27,34c0,0-2.3,0-3.4,0c-0.7,0-1.1,0.5-1.1,1c0,0.5,0.5,1,1.7,1C25.9,36,27,34,27,34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6d00",
    d: "M22.3,35.5C21.7,35,22,34,22.8,34h1.6c0.7,0,1.1,0.5,1.1,1c0,0.5-0.5,1-1.7,1 C23.3,36,22.8,35.8,22.3,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9100",
    d: "M21 19h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1S21.6 19 21 19zM32 19h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1S32.6 19 32 19zM20.1 21h-1.3v2.2H21V29h2v-5.1C23 22.3 21.7 21 20.1 21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14,22.2c0-1.3,4.6-1.3,4.6-1.3s3.4,0,3.4,2.5c0,1.8-2.8,2.5-4.4,2.5C15.8,26,14,24.7,14,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M18 22A1 1 0 1 0 18 24A1 1 0 1 0 18 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9100",
    d: "M24,32c-1.7,0-3-1.3-3-3c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6,0.4,1,1,1c0.6,0,1,0.4,1,1S24.6,32,24,32z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaitama);
export default __webpack_public_path__ + "static/media/saitama.e7b15044ad97ed90a4fcd3a296004e60.svg";
export { ForwardRef as ReactComponent };